import './index.scss';

class aPhone {
    captcha = null;
    masksPhoneComplete = {};

    /**
     * Добавляет поле для ввода смс кода
     * @param field
     * @param inputPhone
     */
    addSmsInput(field, inputPhone) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        let iSms = field.querySelector('.' + cls.iSms);
        if (iSms === null) {
            let code = self.options.values.code;
            iSms = base.create('input', [cls.iSms], 'sms', '');

            iSms.setAttribute('name', code.name);
            iSms.setAttribute('type', code.type);
            if ('required' in code && code.required === 'true')
                iSms.setAttribute('required', code.required);
            iSms.setAttribute('maxlength', code.maxLengthCode);
            iSms.setAttribute('placeholder', code.placeholder);

            iSms.addEventListener('input', function (e) {
                if (iSms.value.length === 4) {
                    self.form.toggleError(iSms, false);
                    self.toggleLinkNewPhone(field, false);
                    self.validatePhone({sms: iSms.value}, 'validate',
                        iSms.closest('.' + cls.form), function () {
                            self.toggleLinkNewPhone(field, true);
                        });
                } else self.form.changeInputText(iSms);
            });

            field.appendChild(iSms);
        }

        let mapDepend = ['parent', 'value'];
        for (let d in mapDepend) {
            let attr = 'data-depend-' + mapDepend[d];
            let dataDepend = inputPhone.getAttribute(attr);
            if (dataDepend !== null) iSms.setAttribute(attr, dataDepend);
            else if (iSms.getAttribute(attr) !== null) iSms.removeAttribute(attr);
        }
    };

    /**
     * Подключает плагин inputmask на поле для ввода телефона
     * @param input - инпут с телефоном
     * @param callbackMessage - функция с сообщениями об ошибках
     */
    addMaskedToPhone(input, callbackMessage) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        input.onpaste = function () {
            if (window.clipboardData)
                input.value = window.clipboardData.getData('Text');
            else if (navigator.clipboard)
                navigator.clipboard.readText().then(function (text) {
                    input.value = text;
                });
        };

        if (input.classList.contains(cls.iPhone + '-ru')) {
            if (input.classList.contains(cls.iPhone) && input.getAttribute('inputmode') === null) {
                let mask = '+7 (999) 999-99-99';
                let lengthNumb = mask.replace(/[^\d]/g, '').length;

                $(input).inputmask({
                    mask: mask,
                    showMaskOnHover: false,
                    showMaskOnFocus: false,
                    oncomplete: function () {
                        self.masksPhoneComplete[input.name] = true;
                        self.form.toggleError(this, false);
                        self.toggleLinkSendPhone(input, true);
                    },
                    onincomplete: function () {
                        if (this.value.replace(/[^\d]/g, '') !== '') {
                            if (!this.closest('div').classList.contains(cls.error))
                                this.closest('div').classList.add(cls.error);
                            self.form.appendMess(this, base.msg('A_PHONE_T_ER'));
                        }

                        self.masksPhoneComplete[input.name] = false;

                        self.toggleLinkSendPhone(this, false);
                    },
                    oncleared: function () {
                        self.form.toggleError(this, false);
                        self.toggleLinkSendPhone(this, false);
                    }
                });
                input.addEventListener('input', function (e) {
                    let t = this;
                    self.form.changeInputText(t);
                    self.toggleLinkSendPhone(t, t.value.replace(/[^\d]/g, '').length === lengthNumb);
                });
                input.addEventListener('keydown', function (e) {
                    let t = this;
                    self.form.changeInputText(t);
                    self.toggleLinkSendPhone(t, t.value.replace(/[^\d]/g, '').length === lengthNumb);
                });
            }
        } else if (input.classList.contains(cls.iPhone + '-int')) {
            self.disabledPhone(input);
            self.loadPhoneList();
            input.onblur = function () {
                if (self.getStatusInput(input) === 'clear') {
                    input.value = '';
                    self.form.changeInputText(input);
                } else if (!input.classList.contains(cls.filled)) input.classList.add(cls.filled);
            };
            let temp = setInterval(function () {
                let countries = self.options.values.countries;
                if (Object.keys(countries).length > 0) {
                    clearInterval(temp);
                    if (input.classList.contains(cls.iPhone)
                        && input.getAttribute('im-insert') === null
                        && !input.classList.contains(cls.masked)) {

                        $(input).inputmasks(
                            $.extend(true, {},
                                {
                                    inputmask: {
                                        definitions: {
                                            '#': {
                                                validator: "[0-9]",
                                                cardinality: 1
                                            }
                                        },
                                        showMaskOnHover: false,
                                        isComplete: function (maskMap) {
                                            const regex = /^[+-]?\d*$/;
                                            const mask = maskMap.join('').replaceAll(/[^+\d_]+/g, '');
                                            self.masksPhoneComplete[input.name] = regex.test(mask);

                                            let inputInFocus = document.activeElement.getAttribute('class');
                                            let isOutMessage = !inputInFocus || inputInFocus.indexOf('i_phone-int') === -1;
                                            if (typeof callbackMessage === 'function') callbackMessage(input, isOutMessage);

                                            input.setAttribute('data-mask', maskMap.join(''));
                                            self.prepareRuPhoneCode(input);
                                            let status = self.getStatusInput(input);
                                            if (status === 'complete') {
                                                self.form.toggleError(input, false);
                                                self.toggleLinkSendPhone(input, true);
                                            } else if (status === 'incomplete') self.toggleLinkSendPhone(input, false);
                                        },
                                        oncleared: function () {
                                            self.form.toggleError(input, false);
                                            self.toggleLinkSendPhone(input, false);
                                        },
                                    },
                                    match: /[0-9]/,
                                    replace: '#',
                                    listKey: 'mask',
                                }, {list: countries,}));

                        input.classList.add(cls.masked);
                        input.addEventListener('blur', function () {
                            let t = this,
                                status = self.getStatusInput(t);
                            if (['incomplete', 'clear'].indexOf(status) !== -1) {
                                if (status === 'incomplete') {
                                    if (!t.closest('div').classList.contains(cls.error))
                                        t.closest('div').classList.add(cls.error);
                                    self.form.appendMess(t, base.msg('A_PHONE_T_ER'));
                                }
                            }
                        });
                    }
                }
            });
        }
    };

    /**
     * Отключение автозаполнения поля для ввода телефона
     */
    disabledPhone = function (input) {
        input.setAttribute('autocomplete', 'off');
    };

    constructor(options) {
        let fCls = options && options.cls;
        let fValues = options && options.values;
        this.base = BX.aBase;
        this.form = BX.aForm;
        this.loader = BX.aLoader;

        this.options = {
            cls: {
                confirmed: fCls && options.cls.confirmed ? options.cls.confirmed : 'confirmed',
                disabled: fCls && options.cls.disabled ? options.cls.disabled : 'disabled',
                field: fCls && !BX.type.isNil(options.cls.field) ? options.cls.field : 'form-cmp__question',
                iSms: fCls && options.cls.iSms ? options.cls.iSms : 'i_sms',
                masked: fCls && options.cls.masked ? options.cls.masked : '__masked',
                newPhone: fCls && options.cls.newPhone ? options.cls.newPhone : 'new-phone',
                phone: fCls && options.cls.phone ? options.cls.phone : 'form-cmp__phone',
                phoneAction: fCls && options.cls.phoneAction ? options.cls.phoneAction : 'phone-action',
                sendPhone: fCls && options.cls.sendPhone ? options.cls.sendPhone : 'send-phone',
                sms: fCls && options.cls.sms ? options.cls.sms : 'form-cmp__sms',
            },
            values: {
                code: {
                    placeholder: '____',
                    maxLengthCode: 4,
                    name: 'one-time-code',
                    required: 'true',
                    type: 'number',
                },
                countries: {},
                phone: '',
                status: fValues && options.values.status ? options.values.status : 'emptyPhone',
                theme: fValues && options.values.theme ? options.values.theme : 'red',
                needConfirm: true
            },
            callback: {
                success: null,
                error: null
            }
        };
        this.options.cls = Object.assign(this.form.options.cls, this.options.cls);
    };

    /**
     * Возвращает статус заполненности номера телефона
     * @param input
     * @returns {string|boolean}
     */
    getStatusInput(input) {
        let dMask = input.getAttribute('data-mask');
        let pValue = input.value.replace(/[^\d]/g, '');

        if (dMask === null) return false;
        dMask = dMask.replace(/[^\_\d]/g, '');

        if (pValue.length === 0) return 'clear';
        else if (pValue.length < dMask.length) return 'incomplete';
        else if (pValue.length === dMask.length) return 'complete';
    };

    /**
     * Загрузка списка стран
     */
    loadPhoneList() {
        let self = this;
        let countries = self.options.values.countries;
        if (Object.keys(countries).length === 0) {
            BX.ajax({
                url: '/local/js/phone.mask/data/phone-codes.json',
                async: false,
                method: 'POST',
                timeout: 600,
                dataType: 'json',
                cache: false,
                onsuccess: function (response) {
                    self.options.values.countries = response;
                },
            });
        }
    };

    /**
     * Преобработка кода для России (+79** или 89**)
     * @param input
     */
    prepareRuPhoneCode(input) {
        let stFind = '8 (9';
        let stNew = '7 (9';
        let cVal = input.value.substr(0, stFind.length);
        if (cVal === stFind) {
            input.value = input.value.replace(stFind, stNew);
            setTimeout(function () {
                input.focus();
            }, 40);
        }
    };

    /**
     * Переключение статуса у поля с номером телефона
     * @param input
     * @param fConfirm
     */
    toggleConfirmPhone(input, fConfirm) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        let bField = input.closest('.' + cls.question);
        let fieldTip = bField.querySelector('.' + cls.tip);
        let placeholder = bField.querySelector('.' + cls.placeholder);

        if (fConfirm && !bField.classList.contains(cls.disabled)) {
            bField.classList.add(cls.disabled);
            let spanConfirm = base.create('span', [cls.confirmed], false, '✔');
            base.after(placeholder !== null ? placeholder : input, spanConfirm);
            self.toggleLinkNewPhone(bField, true);

            if (fieldTip === null) {
                fieldTip = base.create('span', [cls.tip], false, '');
                base.after(spanConfirm, fieldTip);
            }

            fieldTip.innerText = base.msg('A_PHONE_T_CONFIRMED');
        } else if (!fConfirm && bField.classList.contains(cls.disabled)) {
            bField.classList.remove(cls.disabled);
            base.remove(bField.querySelector('.' + cls.confirmed));
            self.toggleLinkNewPhone(bField, false);
            if (fieldTip === null) {
                fieldTip = base.create('span', [cls.tip], false, '');
                base.after(placeholder !== null ? placeholder : input, fieldTip);
            }
            fieldTip.innerText = base.msg('A_PHONE_T_PHONE');
        }
    };

    /**
     * Добавление ссылки на сброс кода из смс
     * @param field
     * @param fAdd
     */
    toggleLinkNewPhone(field, fAdd) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        let linkNewPhone = field.querySelector('.' + cls.newPhone);
        if (fAdd && linkNewPhone === null) {
            linkNewPhone = base.create('a', [cls.newPhone], false, '');
            linkNewPhone.setAttribute('href', '#');
            linkNewPhone.addEventListener('click', function (e) {
                e.preventDefault();
                let form = field.closest('.' + cls.form);
                let iPhone = form.querySelector('.' + cls.iPhone);
                self.toggleFieldSms(form, false);
                self.toggleConfirmPhone(iPhone, false);
                self.toggleLinkSendPhone(iPhone, true);
                iPhone.focus();
            });
            field.appendChild(linkNewPhone);
        } else if (!fAdd && linkNewPhone !== null) base.remove(linkNewPhone);
    };

    /**
     * Добавление ссылки на отправку номера телефона
     * @param input
     * @param flagAdd
     */
    toggleLinkSendPhone(input, flagAdd) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        let bField = input.closest('.' + cls.question);
        let linkSend = bField.querySelector('.' + cls.sendPhone);

        if (flagAdd && linkSend === null && bField.querySelector('.' + cls.confirmed) === null && self.options.values.needConfirm) {
            linkSend = base.create('a', [cls.sendPhone], false, '<span>' + base.msg('A_PHONE_T_SEND') + '</span>');
            base.after(bField.querySelector('.' + cls.placeholder), linkSend);
            linkSend.addEventListener('click', function (e) {
                e.preventDefault();
                base.remove(linkSend);
                self.validatePhone({
                        phone: input.value.replace(/[^\d\+]/g, '')
                    },
                    'request',
                    bField.closest('.' + cls.form));
            });
        } else if (!flagAdd && linkSend !== null)
            base.remove(linkSend);
    };

    /**
     * визуальное оформление загузки поля с телефоном
     * @param form
     * @param fLoad
     */
    toggleFieldLoading(form, fLoad) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;
        let loader = self.loader;

        form = form.context ? form.context : form;
        let mapAction = base.find('.' + cls.phoneAction, form);
        for (let i in mapAction) {
            let pAction = mapAction[i];
            let pInput = pAction !== null ? pAction.querySelector('input') : null;

            if (pInput === null) return false;
            if (fLoad) {
                loader.startLoader(pAction, self.options.values.theme);
                pInput.setAttribute('disabled', 'disabled');
            } else {
                loader.stopLoader(pAction);
                pInput.removeAttribute('disabled');
            }
        }
    };

    /**
     * Добавление блока с полем для ввода кода из смс
     * @param form
     * @param flagAdd
     */
    toggleFieldSms(form, flagAdd) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        let fieldSms = form.querySelector('.' + cls.sms);
        let fieldPhone = form.querySelector('.' + cls.phone);
        if (flagAdd && fieldSms === null) {
            let rightClass = fieldPhone.classList.contains(cls.rightQuestion) ? cls.rightQuestion : '';
            let fWidthClass = fieldPhone.classList.contains(cls.fullWidth) ? cls.fullWidth : '';
            let inputPhone = fieldPhone.querySelector('.' + cls.iPhone);

            fieldSms = base.create('div', [cls.question, cls.sms, cls.phoneAction, rightClass, fWidthClass], false, '');
            self.addSmsInput(fieldSms, inputPhone);
            fieldSms.appendChild(base.create('span', [cls.placeholder], false, base.msg('A_PHONE_T_PL_SMS')));
            fieldSms.appendChild(base.create('span', [cls.tip], false, base.msg('A_PHONE_T_SMS')));
            self.toggleLinkNewPhone(fieldSms, true);
            fieldSms.querySelector('.' + cls.placeholder).addEventListener('click', function (e) {
                e.target.closest('.' + cls.question).querySelector('input').focus();
            });
            fieldPhone.style.display = 'none';
            base.after(fieldPhone, fieldSms);
        } else if (!flagAdd && fieldSms !== null) {
            base.remove(fieldSms);
            fieldPhone.style.display = '';
        }
    };

    /**
     * Проверка номера телефона и кода из смс
     * @param data
     * @param step
     * @param form
     * @param callback
     */
    validatePhone(data, step, form, callback) {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;
        let values = self.options.values;

        data.step = step;
        if (values.phone !== '' && step === 'validate')
            data.phone = values.phone;

        let iFormSID = form.querySelector('[name="form_sid"]');
        if (iFormSID !== null) data.form_sid = iFormSID.value;

        self.toggleFieldLoading(form, true);

        if (self.captcha !== null) data = self.captcha.updateData(data);

        BX.ajax.runComponentAction(
            'aton:form.types',
            'submitPhoneNumber',
            {
                url: location.pathname,
                method: 'post',
                mode: 'class',
                data: {
                    dataSend: data,
                },
            }).then(function (request) {
                self.toggleFieldLoading(form, false);
                if (request.status === 'success' && request.data.result.status === 'success') {
                    if (step === 'request') {
                        if (request.data.result.captcha && request.data.result.captcha === 'y') {
                            if (self.captcha === null) {
                                self.captcha = new AtonCaptcha(form, {classes: {field: cls.field}});
                                self.captcha.init();
                            } else self.captcha.reload();

                            if (request.data.error !== '') {
                                base.showPopup(request.data.result.alert, request.data.result.error);
                            }
                            let promise = new Promise((resolve) => {
                                self.toggleLinkSendPhone(form.querySelector('.' + cls.iPhone), true);
                                return resolve();
                            });
                            promise.then(() => {
                                let btnSubmit = form.querySelector('[type="submit"]');
                                if (btnSubmit) {
                                    btnSubmit.setAttribute('disabled', 'disabled');
                                    btnSubmit.classList.add(cls.disabled);
                                }
                            });
                        } else {
                            if (self.captcha !== null) {
                                BX.aBase.remove(self.captcha.captcha);
                                self.captcha = null;
                            }
                            self.options.values.phone = data.phone;
                            self.toggleFieldSms(form, true);
                            self.toggleLinkSendPhone(form.querySelector('.' + cls.iPhone), false);

                            let btnSubmit = form.querySelector('[type="submit"]');

                            if (btnSubmit) {
                                btnSubmit.removeAttribute('disabled');
                                btnSubmit.classList.remove(cls.disabled);
                            }
                        }
                    } else if (step === 'validate') {
                        let phoneField = form.querySelector('.' + cls.iPhone);
                        self.toggleFieldSms(form, false);
                        self.toggleConfirmPhone(phoneField, true);
                        self.form.toggleError(phoneField, false);
                    }
                    if (typeof callback === 'function') callback();
                    if (typeof self.options.callback.success === 'function') self.options.callback.success(form);
                } else base.showPopup(base.msg('A_PHONE_T_ERROR'), base.msg('A_PHONE_T_UNKNOWN'));

            }
        ).catch(function (request) {
            self.toggleFieldLoading(form, false);
            if (typeof callback === 'function') callback();
            if (request.status === 'error') {
                for (let i in request.errors) {
                    let error = request.errors[i];
                    if (error.code !== 0) {
                        console.error('Error: ', error.message);
                        base.showPopup(base.msg('A_PHONE_T_ERROR'), error.message);
                        break;
                    }
                }
            }
        });
    };
}

BX.aPhone = new aPhone();